import { Scheduler } from '../../components/scheduler/Scheduler.jsx'
import { getEvents } from '../../features/schedulerSlice.js'
import { fetchEventTags } from '../../features/guestListSlice.js'
import { TimeLineProfileFilters } from './TimeLineProfileFilters.jsx'
import { getKazooMembers } from '../../features/kazooEventSlice.js'

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
	VendorTasksTemplate,
	VendorTasksTemplateFooter,
	VendorTasksTemplateHeader,
} from '../../components/scheduler/VendorTasksTemplate.jsx'
import { TimeLineHeader } from './TimeLineHeader.jsx'
import styles from './timeLineStyle.module.scss'

export const VendorKazooTimelinePage = () => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const timelineEvents = useSelector(
		(state) => state.scheduler.timelineEvents
	)

	const partyMembers = useSelector((state) => state.scheduler.selectedUsers)

	useEffect(() => {
		dispatch(getEvents(kazooId)) // to display events
		dispatch(fetchEventTags(kazooId))
		dispatch(getKazooMembers(kazooId))
	}, [dispatch, kazooId])

	const eventSettings = {
		allowAdding: false,
		allowEditing: true,
		allowDeleting: false,
		allowResizing: false,
		allowDrag: false,
		dataSource: timelineEvents.map((event) => ({
			...event,
		})),
	}

	return (
		<div className={styles.pageWrap}>
			<TimeLineHeader title="Itinerary" />
			<TimeLineProfileFilters />
			<div className={styles.schedulerWrap}>
				<div className="calendarWrp commonCalendar ">
					<div className="calendarInner">
						<Scheduler
							// editorTemplate={VendorTasksTemplate}
							// editorHeaderTemplate={VendorTasksTemplateHeader}
							// editorFooterTemplate={VendorTasksTemplateFooter}
							eventSettings={eventSettings}
							partyMembers={partyMembers}
							allowDragAndDrop={false}
							allowResizing={false}
							height="77dvh"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
